<div class="modal-confirm" data-cy="modal-confirm" [ngStyle]="{'width.px': setWidth()}">
  <div class="modal-header" [ngClass]="getHeaderClass()">
    <p class="modal-title" data-cy="modal-confirm-title">{{titleText}}</p>
    @if (hasCloseButton) {
      <button data-cy="modal-confirm-close-button" type="button" class="close" (click)="activeModal.dismiss()"></button>
    }
  </div>

  <div class="modal-body">
    <div class="modal-confirm-subtitle" data-cy="modal-manual-subtitle" [innerHTML]="subtitleText"></div>
    @if (showManualInputs()) {
      <section class="modal-checks-section">
        <div class="modal-checks-title" [innerHTML]="manualChecks.title"
        data-cy="modal-manual-checks-title"></div>
        @for (manualCheck of manualChecks.inputs; track manualCheck; let index = $index) {
          <ng-container class="modal-checks">
            <div class="modal-checks">
              <input type="checkbox" [checked]="manualCheck.checked"
                data-cy="modal-manual-manual-check-input"
                class="modal-manual-check"
                (change)="toggleManualCheck(manualCheck)"
                id="manual-check-{{index}}">
              <label class="{{applyLabelClass(manualCheck)}}"
                data-cy="modal-manual-manual-check-label"
                for="manual-check-{{index}}"
              [textContent]="manualCheck.message"></label>
            </div>
          </ng-container>
        }
      </section>
    }
  </div>

  <div class="modal-footer">
    @if (tertiaryButtonText || false) {
      <button type="button"
        [disabled]="isTertiaryButtonDisabled()"
        class="btn-text-link"
        (click)="clickTertiaryButton()"
      data-cy="modal-tertiary-button">{{tertiaryButtonText}}</button>
    }
    @if (secondaryButtonText || false) {
      <button type="button"
        [disabled]="isSecondaryButtonDisabled()"
        class="btn-secondary"
        (click)="clickSecondaryButton()"
      data-cy="modal-secondary-button">{{secondaryButtonText}}</button>
    }
    @if (primaryButtonText || false) {
      <button type="button"
        class="{{getPrimaryButtonClass()}}"
        [disabled]="disablePrimaryButton()"
        (click)="clickPrimaryButton()"
      data-cy="modal-primary-button">{{primaryButtonText}}</button>
    }
  </div>
</div>
